import {redirect as redirectTo} from '@tanstack/react-router'

import {LOGIN_DEFAULT_REDIRECT} from '@/auth/config'
import {isAuthenticatedAtom} from '@/auth/hooks/useIsAuthenticated'

/**
 * Only allow guests (non-authenticated users) to access the route.
 *
 * @param store - Jotai store
 * @param redirect - The route to redirect to if the user is authenticated.
 */
export default function guestRoute(store: ReturnType<typeof useStore>, redirect?: string) {
  const isAuthenticated = store.get(isAuthenticatedAtom)
  if (isAuthenticated) {
    throw redirectTo({
      to: redirect ?? LOGIN_DEFAULT_REDIRECT,
    })
  }
}
